<template>
  <div class="com-table balance border">
    <div class="com-title pr">招商智投（普投）-竞价</div>
    <div class="wrap-list">
      <el-dialog
        :title="row.title"
        width="700px"
        :visible.sync="visible"
        :before-close="handleClose">
        <el-form class="form" label-width="180px" :model="row.form" ref="formModifyRow">
          <el-form-item label="起止日期" :rules="[{required: true, message: '请选择起止日期'}]">
            <el-col>
              <el-date-picker
                v-model="row.form.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :value-format="row.format"
                clearable>
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="导出项目" prop="id" :rules="[{required: true, message: '请选择导出项目'}]">
            <el-select v-model="row.form.id">
              <template v-for="item in items">
                <el-option :label="item.title" :value="item.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="已读状态" prop="readStatus" :rules="[{required: true, message: '请选择已读状态'}]">
            <el-select v-model="row.form.readStatus">
              <el-option label="不限" :value="-1"></el-option>
              <el-option label="未读" :value="0"></el-option>
              <el-option label="已读" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导出格式" prop="fileGenre" :rules="[{required: true, message: '请选择导出格式'}]">
            <el-select v-model="row.form.fileGenre">
              <el-option label="CSV格式" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFile()" class="dia-btn">导出</el-button>
            <!--<el-button @click="resetForm('formModifyRow')">重置</el-button>-->
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-row class="operation">
        <el-button-group>
          <el-button type="primary" size="small" :data="search.list" @click="download"><icon name="cloud-download"/>导出</el-button>
        </el-button-group>
      </el-row>

      <ms-search :data="search.list" @click="updateConditions"></ms-search>

      <template v-if="showData">
        <div class="table-learn">
          <div class="mask">
            <el-checkbox-button v-model="is_check" @change="select_all()" class="small-button">全选/反选</el-checkbox-button>
            <el-button size="small" type="success" @click="read()">标为已读</el-button>
            <el-button size="small" type="primary" @click="unRead()">标为未读</el-button>
            <el-button size="small" type="danger" @click="deleteList()">批量删除</el-button>
            <el-button size="small" type="primary" @click="distributeAll()">批量手动分配</el-button>
          </div>

          <!-- <el-button type="primary" size="small" @click="addRow()">
            <icon name="cloud-download"/>&nbsp;&nbsp;留言导出
          </el-button> -->
        </div>
        <div class="table-wrap">
          <table cellspacing="0"
                 class="table table-bordered"
                 v-for="(item,index) in table.list">
            <tbody>
            <tr>
              <td width="30" rowspan="5">
                <p><input type="checkbox" :checked="item.flag" @click="is_check_fn(index)"></p>
              </td>
              <td width="20%"><strong>ID：</strong>{{item.id}}</td>
              <td><strong>项目名称：</strong>{{item.itemTitle}}</td>
              <td>
                <strong>投放端：</strong>
                <ms-device :client-id="item.clientId"></ms-device>
              </td>
              <td colspan="2"><strong>自定义来源：</strong>{{item.source}}</td>
              <td rowspan="5" class="feedback">
                <p><strong>留言内容：</strong>
                  <span v-if="item.content.startsWith('{')">
                    <div v-for="(value,key) in item.datas">
                      <span>{{key}}：{{value}}</span>
                    </div>
                  </span>
                  <span v-else>{{ item.content }}</span>
                </p>
                <icon name="flag"></icon>
                来自{{item.genreTitle}}

                <p v-if="item.ipArea !== undefined && !item.searchWord">
                  <icon name="search"></icon> 通过关键词
                  <el-popover
                    placement="top-start"
                    width="380">
                  <span slot="reference">
                    <a style="cursor: pointer">{{item.searchWord}}</a> 访问
                  </span>
                    <table class="ms-table">
                      <tbody>
                      <tr>
                        <td class="left" style="width: 60px;"><strong>搜索引擎</strong></td>
                        <td class="left">{{item.searchTitle}}</td>
                      </tr>
                      <tr>
                        <td class="left"><strong>搜索词</strong></td>
                        <td class="left">{{item.searchWord}}</td>
                      </tr>
                      <tr>
                        <td class="left"><strong>来源页</strong></td>
                        <td class="left">
                          <a class="over-hidden" :href="item.referrerUrl" target="_blank">{{item.referrerUrlView}}</a>
                        </td>
                      </tr>
                      <tr>
                        <td class="left"><strong>着路页</strong></td>
                        <td class="left">
                          <a class="over-hidden" :href="item.pageUrl" target="_blank">{{item.pageUrl}}</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </el-popover>
                </p>
              </td>
            </tr>
            <tr>
              <td><strong>姓名：</strong>{{item.contacts}}</td>
              <td><strong>手机号码：</strong>{{item.mobile}}</td>
              <td><strong>电话：</strong>{{item.phone}}</td>
              <td colspan="2"><strong>QQ：</strong>{{item.qq}}</td>
            </tr>
            <tr>
              <td><strong>创建时间：</strong>{{item.publishTime}}</td>
              <td colspan="4"><strong>地域：</strong>
                {{item.address}}
                <span v-if="item.ipArea !== undefined && item.ipAre !== '' && item.ipArea !== '中国'">（IP来自 {{item.ipArea}}）</span>
              </td>
              <!-- <td colspan="2"><strong>平台名称：</strong>
                {{item.channelsTitle}}
              </td> -->
            </tr>
            <tr>
              <td class="active" :colspan="item.showPageUrl?1:5">
                <strong>操作：</strong>
                <a @click="deleteRow(index)">删除</a>
                <a v-if="item.readStatus === 0" @click="setting(index)"><i class="read"></i>标为已读</a>
                <a class="no-read" v-if="item.readStatus === 1" @click="setting(index)">标为未读</a>
              </td>
              <td colspan="4" v-if="item.showPageUrl" style="white-space: nowrap;">
                <strong>落地页：</strong>
                <a class="pageUrl" target="_blank" :href="item.pageUrl">{{item.pageUrl}}</a>
              </td>
            </tr>
            <tr>
              <td><strong>接收人：</strong>{{item.crmFollower}}</td>
              <td colspan="3"><strong>备注：</strong>
                {{item.remark}}
                <span @click="showRemark(index)" style="cursor: pointer">
                  <icon name="pencil-square-o"></icon>
                </span>
              </td>
              <td class="active">
                <template v-if="item.crmFollower.length > 0 || (item.remark && item.remark.indexOf('与crm资源重复')>-1)">
                  已分配
                </template>
                <template v-else>
                  <a @click="distribution(index)">手动分配</a>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-else>
        <no-data></no-data>
      </template>

      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="table.pagination.page"
        :total="table.pagination.totalRow"
        :page-size="table.pagination.pageSize"
        :page-sizes="table.pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <!-- 修改备注-->
    <el-dialog title="修改备注" :visible.sync="dialogVisible" width="30%" top="15%" center :before-close="handleClose">
      <el-input type="textarea" :rows="10" v-model="message.remark" placeholder="请输入内容"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="modifierRemrak">提 交</el-button>
      </span>
    </el-dialog>
    <!--手动分配-->
    <el-dialog center align = "center" :visible.sync="dialogFpVisible" width="40%" :close-on-click-modal="false">
      <p style="text-align:center;">
        接收人：
        <el-select v-model="distribute.id" filterable remote placeholder="请输入话务人员姓名" :remote-method="remoteMethod" :loading="loading" style="width:50%">
          <template v-if="channelSource === 2">
            <el-option v-for="item in userList" :key="item.id" :label="item.sourceName" :value="item.sourceId"></el-option>
          </template>
          <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id" v-else></el-option>
        </el-select>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="loading" @click="saveDistribute">确 定</el-button>
        <el-button @click="dialogFpVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import MsSearch from '@/components/common/Search.vue'
  import moment from 'moment'
  import MsConfirmButton from '@/components/common/ConfirmButton.vue'
  import MsDevice from '@/components/common/Device.vue'
  import MsSlide from '@/components/common/Slide.vue'
  import Items from '@/api/items'
  import Api from '@/api/feedback'
  import ResponseParse from '@/utils/response-parse'
  import {
    GENRES, SEARCH_CONDITION, SEARCH_ENGINES,
    TEMPLATE_STYLES
  } from '@/models/feedbacks'
  export default {
    components: {
      MsSlide,
      MsSearch,
      MsConfirmButton,
      MsDevice
    },
    data () {
      return {
        userInfo: {},
        visible: false,
        showData: false,
        is_check: false,
        dialogVisible: false,
        dialogFpVisible: false,
        currentPage: 1,
        currentSize: 0,
        distribute: {},
        userList: [],
        search: {
          list: [],
          condition: {}
        },
        table: {
          list: [],
          pagination: {}
        },
        message: {
          id: 0,
          remark: ''
        },
        row: {
          questionnaire: [],
          title: '留言导出',
          enabled: false,
          format: 'yyyy-MM-dd',
          form: {
            date: [],
            id: '',
            fileGenre: '',
            readStatus: ''
          }
        },
        items: [],
        channelSource: 1 // 2:按客人来源 1:按员工来源(默认)
      }
    },
    created () {
      this.userInfo = JSON.parse(sessionStorage.getItem('user'))
      this.search.list = SEARCH_CONDITION
      let date = []
      date[0] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      date[1] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      this.search.condition.startTime = date[0]
      this.search.condition.endTime = date[1]
      this.search.list[0].value = date
      Api.itemTitle({search: {modeType: 1}}, response => {
        let itemTitle = response.data.data
        let title = []
        itemTitle.forEach(value => {
          title.push({value: value.title, label: value.title})
        })
        this.search.list[1].config.list = title
      })
      this.table.list = []
      this.requestList()
      this.getChannerSource()
    },
    methods: {
      async getChannerSource () {
        let response = await Api.getCrmAssignResourceType()
        let status = response.status || 0
        let body = response.data || {}
        if (status >= 200 || status <= 204) {
          this.channelSource = body.assignResourceType
        }
      },
      is_check_fn (index) {
        /* 对应点击时，修改is_check集合对应的值 */
        let data = Object.assign({}, this.table.list[index], {flag: !this.table.list[index].flag})
        this.table.list.splice(index, 1, data)
      },
      select_all () {
        for (let i = 0; i < this.table.list.length; i++) {
          this.table.list[i].flag = !this.table.list[i].flag
        }
      },
      read () {
        let ids = []
        for (let i = 0; i < this.table.list.length; i++) {
          if (this.table.list[i].flag) {
            ids.push(this.table.list[i].id)
          }
        }
        Api.readMul({ids: ids}, () => {
          this.requestList()
        })
      },
      deleteList () {
        let ids = []
        for (let i = 0; i < this.table.list.length; i++) {
          if (this.table.list[i].flag) {
            ids.push(this.table.list[i].id)
          }
        }
        if (ids.length === 0) {
          this.$message.error('请先选择列表数据！')
          return
        }
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          Api.deleteList({ids: ids}, () => {
            this.requestList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      distributeAll () {
        let resourceList = []
        const list = this.table.list
        for (let i = 0; i < list.length; i++) {
          if (list[i].flag) {
            const form = {}
            form.id = list[i].id
            form.taleName = list[i].tableName
            resourceList.push(form)
          }
        }
        if (resourceList.length === 0) {
          this.$message.error('请先选择列表数据！')
          return
        }
        this.distribute.resourceList = resourceList
        if (this.channelSource === 3) {
          this.thridPush()
        } else {
          this.dialogFpVisible = true
        }
      },
      unRead () {
        let ids = []
        for (let i = 0; i < this.table.list.length; i++) {
          if (this.table.list[i].flag) {
            ids.push(this.table.list[i].id)
          }
        }
        Api.unReadMul({ids: ids}, () => {
          this.requestList()
        })
      },
      requestList () {
        let params = Object.assign({}, this.table.pagination, this.search.condition)
        Api.list({search: params}, response => {
          let status = response.status || 0
          let body = response.data || []
          if ((status >= 200 || status <= 204) && body.length > 0) {
            this.table.list = body.map(item => {
              item.flag = false
              item.genreTitle = item.genreId > 0 && GENRES.hasOwnProperty(item.genreId) ? GENRES[item.genreId] : '其他'
              item.templateStyleTitle = TEMPLATE_STYLES[item.templateStyle] || '自定义模板'

              item.searchTitle = SEARCH_ENGINES[item.searchDomain]
              item.referrerUrlView = item.referrerUrl && item.referrerUrl.length > 100
                ? item.referrerUrl.substr(0, 50) + '...' + item.referrerUrl.substr(-30, 30) : item.referrerUrl

              if (item.content.startsWith('{')) {
                item.datas = {}
                let record = JSON.parse(item.content)
                if (record.wechart !== undefined) {
                  item.datas['微信'] = record.wechart
                }
                if (record.feedback !== undefined) {
                  item.datas['留言'] = record.feedback
                }
                if (record.visitTime !== undefined) {
                  item.datas['回访时间'] = record.visitTime
                }
                if (record.visitTime !== undefined) {
                  item.datas['回访时间'] = record.visitTime
                }
                if (record.sex !== undefined) {
                  item.datas['性别'] = record.sex
                }
                if (record.budget !== undefined) {
                  item.datas['投资预算'] = record.budget
                }
              } else {
                item.content = item.content === '请选择你需要的面积' ? '' : item.content
              }
              return item
            })
            this.showData = true
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.showData = false
            this.table.list = []
          }
        })
      },
      thridPush () {
        this.$confirm('确定操作？', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '分配中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          Api.assignResourcesManuallyByThridPush({form: this.distribute}, response => {
            loading.close()
            let status = response.status || 0
            let body = response.data || []
            if (status >= 200 && status <= 204) {
              this.$message.success(body.submitResult ? '操作成功：' + body.submitResult : '分配成功')
              this.requestList()
            } else {
              this.$message.error(body.error ? '操作失败：' + body.error : '分配失败')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      },
      distribution (index) {
        const item = this.table.list[index]
        let form = {}
        form.id = item.id
        form.taleName = item.tableName
        this.distribute.resourceList = [form]
        if (this.channelSource === 3) {
          this.thridPush()
        } else {
          this.dialogFpVisible = true
        }
      },
      remoteMethod (query) {
        let search = {}
        search.userName = query
        let ApiName = 'likeness'
        if (this.channelSource === 2) {
          ApiName = 'speLikeness'
          search.userName = ''
          search.sourceName = query
        }
        Api[ApiName]({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.userList = body
          }
        })
      },
      saveDistribute () {
        this.loading = true
        let ApiName = 'distribute'
        if (this.channelSource === 2) {
          ApiName = 'speDistribute'
          this.distribute.channelSourceCode = this.distribute.id
        } else {
          this.distribute.userId = this.distribute.id
        }
        Api[ApiName]({form: this.distribute}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.dialogFpVisible = false
            this.$message.success(body.submitResult ? '操作成功：' + body.submitResult : '分配成功')
            this.requestList()
          } else {
            this.$message.error(body.error ? '操作失败：' + body.error : '分配失败')
          }
          this.loading = false
        })
      },
      showRemark (index) {
        this.dialogVisible = true
        const item = this.table.list[index]
        this.message.index = index
        this.message.remark = item.remark
        this.message.id = item.id
      },
      modifierRemrak () {
        Api.modifyFeedbackRemark({id: this.message.id, remark: this.message.remark}, response => {
          let status = response.status || 0
          if (status >= 200 && status <= 204) {
            let data = this.table.list[this.message.index]
            data.remark = this.message.remark
            this.table.list.splice(this.message.index, 1, data)
            this.dialogVisible = false
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1

        const time = conditions.time || []
        this.search.condition = Object.assign({}, conditions, {startTime: time[0], endTime: time[1]})
        this.requestList()
      },
      showQuestionnaire (index) {
        const item = this.table.list[index]
        Api.getOpenQuestionnaire({id: item.id}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status >= 200 && status <= 204) {
            this.row.questionnaire = JSON.parse(body.content || '[]')
          } else {
            this.row.questionnaire = []
          }
        })
      },
      deleteRow (index) {
        const item = this.table.list[index]
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          Api.delete({id: item.id}, response => {
            let status = response.status || 0
            let body = response.data || {}
            if (status >= 200 && status <= 204) {
              this.table.list.splice(index, 1, Object.assign({}, item, {status: -1}))
            } else {
              this.$message.error(body.error || '操作失败')
            }
            this.requestList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      setting (index) {
        const item = this.table.list[index]
        if (item.readStatus === 1) {
          Api.unread({id: item.id}, response => {
            let status = response.status || 0
            let body = response.data || {}
            if (status >= 200 && status <= 204) {
              this.table.list[index].readStatus = 0
              this.$message.success('操作成功')
              this.$store.commit('increment')
            } else {
              this.$message.error(body.error || '操作失败')
            }
          })
        } else if (item.readStatus === 0) {
          Api.read({id: item.id}, response => {
            let status = response.status || 0
            let body = response.data || {}
            if (status >= 200 && status <= 204) {
              this.table.list[index].readStatus = 1
              this.$message.success('操作成功')
              this.$store.commit('decrement')
            } else {
              this.$message.error(body.error || '操作失败')
            }
          })
        }
      },
      addRow () {
        this.row.form = {}
        // 获得 所有项目
        Items.getItems(response => {
          let status = response.status.code
          let body = response.data.data
          if (status === '200') {
            this.items = body
          }
        })
        this.visible = true
//        this.showSlide('slideModifyRow')
      },
      exportFile () {
        this.$refs['formModifyRow'].validate((valid) => {
          if (valid) {
            let $data = this.row.form
            let parameters1 = '?startTime=' + $data.date[0] + '&endTime=' + $data.date[1]
            let parameters2 = '&itemId=' + $data.id
            let parameters3 = '&fileGenre=' + $data.fileGenre
            let parameters4 = '&readStatus=' + $data.readStatus

            window.location.href = '/rest/customer/feedback/feedbacks/files' +
              parameters1 + parameters2 + parameters3 + parameters4
          } else {
            return false
          }
        })
      },
      download (conditions) {
        let search = ''
        let flag = true
        this.search.list.forEach(item => {
          let text = item.name
          let value = item.value
          if (item.type === 'select') {
            if (item.hasOwnProperty('config') && item.config.hasOwnProperty('list')) {
              item.config.list.forEach(function (option) {
                if (option.label === item.value) {
                  value = option.value
                }
              })
            }
          }
          if (search === '') {
            if (text === 'time' && value !== '') {
              if (value === null) {
                this.$message({
                  type: 'error',
                  message: '请选择时间范围'
                })
                flag = false
              }
              search = '?startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== null && value !== '' && value !== undefined) {
                search = '?' + text + '=' + value
              }
            }
          } else {
            if (text === 'time' && value !== '') {
              if (value === null) {
                this.$message({
                  type: 'error',
                  message: '请选择时间范围'
                })
                flag = false
              }
              search = '&startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== null && value !== '' && value !== undefined) {
                search += '&' + text + '=' + value
              }
            }
          }
        })
        if (flag) {
          window.location.href = '/rest/customer/feedback/feedbacks/downloadlist' + search
        }
      },
      showSlide (ref) {
        this.$refs[ref].show()
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>
<style lang="scss">
  .wrap-list {
    .el-select{
      width: 60%;
    }
    .dia-btn{
      width: 150px;
      height: 40px;
    }
    .table-learn {
      .mask {
        .small-button {
          .el-checkbox-button__inner {
            padding:8px;
          }
        }
      }
      .el-button--success {
        margin:0;
      }
    }
  }
</style>
<style lang="scss" scoped>
  @import "../../assets/styles/env";
  .pageUrl{
    max-width: 420px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .no-data {
    text-align: center;
    color: #8f9196;
    padding: 20px;
    border: 1px solid #ebedf1;
  }
  .wrap-list {
    padding-top: 10px;
    position: relative;
    .operation{
      position: absolute;
      top:13px;
      right: 0px;
      z-index: 99;
    }
  }
  .read{
    width:8px;
    height:8px;
    background:#f00;
    border-radius:50%;
    display: inline-block;
    position: relative;
    top:-1px;
    margin:0 2px;
  }
  .check-btn {
    padding: 4px 10px;
  }

  .el-table__column-filter-trigger {
    padding-left: 5px;
  }

  .over-hidden {
    overflow: hidden;
    display: inline-block;
    width: 345px;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }

  .el-popover {
    overflow: hidden;
  }

  .element-table th {
    height: 48px;
  }

  .table-expand {
    text-align: left;
    label {
      width: 80px;
      line-height: 28px;
      font-weight: bold;
    }
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: calc((100% - 100px) / 2);
      &__content {
        line-height: 28px;
      }
    }
    .content {
      width: 88%;
    }
  }

  .ms-table {
    width: 100%;
    border-collapse: collapse;
    th {
      padding: 8px 5px;
    }
    td, th {
      text-align: center;
      word-break: break-all;
      padding: 5px;
      &.left {
        text-align: left;
      }
      p {
        margin: 2px 0;
      }
      a {
      }
    }
    &.ms-table-striped {
      tr:nth-child(even) {
        td {
          background-color: $color-tint;
        }
      }
    }
  }

  .table-learn {
    margin-bottom: 10px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    input {
      vertical-align: middle;
    }
    a {
      cursor: pointer;
    }
  }

  .table-bordered {
    border: 1px solid #b4c0da;
    border-bottom: none;
    border-collapse: separate;
    border-left: 0;
    font-size: 12px;
    color: #606266;
    tr {
      td {
        border-left: 1px solid #b4c0da;
        border-bottom: 1px solid #b4c0da;
        padding: 6px 10px;
      }
      &:nth-child(odd) td {
        background-color: #FAFAFA;
      }
      .feedback {
        word-wrap: break-word;
        width: 24%;
      }
      .active a {
        cursor: pointer;
      }
      .active {
        .no-read {
          color: red;
        }
      }
    }
  }

  .table {
    width: 100%;
    margin-bottom: 35px;
    background: #f5f7fa;
  }
  .table-wrap {
    background: #e2e7f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/Feedback.vue